import React from 'react';

import { useNavigate } from 'react-router-dom';

import { FiArrowRight, FiCreditCard, FiShare2, FiUsers, FiZap, FiRadio } from 'react-icons/fi';

import './Landing.css';



const Landing = () => {

  const navigate = useNavigate();



  const features = [

    {

      icon: <FiCreditCard size={32} />,

      title: 'Digital Business Cards',

      description: 'Create stunning digital cards that make lasting impressions',

    },

    {

      icon: <FiRadio size={32} />,

      title: 'NFC Technology',

      description: 'Share your card instantly with a simple tap using NFC',

    },

    {

      icon: <FiShare2 size={32} />,

      title: 'Instant Sharing',

      description: 'Share via QR code, link, or social media in seconds',

    },

    {

      icon: <FiUsers size={32} />,

      title: 'Contact Management',

      description: 'Save and organize all your business connections',

    },

    {

      icon: <FiZap size={32} />,

      title: 'Always Updated',

      description: 'Changes sync instantly across all platforms',

    },

  ];



  return (

    <div className="landing-container">

      <div className="landing-content">

        {/* Hero Section */}

        <div className="hero-section">

          <div className="hero-logo-wrapper">

            <img src="/logo.png" alt="OMNI" className="hero-logo" />

          </div>

          <h1 className="hero-title">

            Welcome to <span className="gradient-text">OMNI</span>

          </h1>

          <p className="hero-subtitle">

            Your Professional Digital Business Card Platform

          </p>

          <p className="hero-description">

            Create, share, and manage your digital business cards with ease. 

            Make networking seamless and leave a lasting impression.

          </p>

          

          <div className="hero-actions">

            <button className="btn-hero-primary" onClick={() => navigate('/login')}>

              Get Started

              <FiArrowRight size={20} />

            </button>

            <button className="btn-hero-secondary" onClick={() => navigate('/register')}>

              Create Account

            </button>

          </div>



          {/* Download App Buttons */}

          <div className="download-section">

            <p className="download-text">Download our mobile app</p>

            <div className="download-buttons">

              <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer" className="download-link">

                <img src="/Google_Play.png" alt="Get it on Google Play" className="download-badge" />

              </a>

              <a href="https://apps.apple.com" target="_blank" rel="noopener noreferrer" className="download-link">

                <img src="/Apple_Store.png" alt="Download on the App Store" className="download-badge" />

              </a>

            </div>

          </div>

        </div>



        {/* Features Grid */}

        <div className="features-section">

          <h2 className="features-title">Why Choose OMNI?</h2>

          <div className="features-grid">

            {features.map((feature, index) => (

              <div key={index} className="feature-card">

                <div className="feature-icon">{feature.icon}</div>

                <h3 className="feature-title">{feature.title}</h3>

                <p className="feature-description">{feature.description}</p>

              </div>

            ))}

          </div>

        </div>



        {/* CTA Section */}

        <div className="cta-section">

          <div className="cta-card">

            <h2 className="cta-title">Ready to Go Digital?</h2>

            <p className="cta-description">

              Join thousands of professionals who've modernized their networking

            </p>

            <button className="btn-cta" onClick={() => navigate('/login')}>

              Start Your Journey

              <FiArrowRight size={20} />

            </button>

          </div>

        </div>



        {/* Footer */}

        <footer className="landing-footer">

          <p>&copy; 2026 OMNI. All rights reserved.</p>

          <div className="footer-links">

            <a href="/privacy" className="footer-link">Privacy Policy</a>

            <span className="footer-divider">|</span>

            <a href="/terms" className="footer-link">Terms &amp; Conditions</a>

          </div>

        </footer>

      </div>

    </div>

  );

};



export default Landing;

